import React from 'react';
import './anchor-styles.css';

/**
 * Dashboard Metrics Component - Displays KPI cards
 */
const DashboardMetrics = ({ metrics, loading }) => {
  if (loading) {
    return (
      <div className="row">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="col-lg-3 col-md-6" style={{ marginBottom: '20px' }}>
            <div className="metric-card loading-skeleton">
              <div className="skeleton-header"></div>
              <div className="skeleton-value"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const metricCards = [
    {
      title: 'Pending Invoices',
      value: metrics?.pendingInvoicesCount || 0,
      icon: '📋',
      color: '#FF9800',
      bgColor: '#FFF3E0',
      subtitle: 'Awaiting approval'
    },
    {
      title: 'Approved This Month',
      value: `₹${formatCurrency(metrics?.approvedThisMonth || 0)}`,
      icon: '✅',
      color: '#4CAF50',
      bgColor: '#E8F5E9',
      subtitle: 'Current month'
    },
    {
      title: 'Total Financed (YTD)',
      value: `₹${formatCurrency(metrics?.totalFinancedYTD || 0)}`,
      icon: '💰',
      color: '#1976D2',
      bgColor: '#E3F2FD',
      subtitle: 'Year to date'
    },
    {
      title: 'Available Credit',
      value: `₹${formatCurrency(metrics?.availableCredit || 0)}`,
      icon: '💳',
      color: '#9C27B0',
      bgColor: '#F3E5F5',
      subtitle: 'Remaining limit'
    },
    {
      title: 'Average Approval Time',
      value: `${metrics?.avgApprovalTime || 0} days`,
      icon: '⏱️',
      color: '#FF5722',
      bgColor: '#FBE9E7',
      subtitle: 'Processing time'
    },
    {
      title: 'Active Suppliers',
      value: metrics?.supplierCount || 0,
      icon: '🏢',
      color: '#00BCD4',
      bgColor: '#E0F7FA',
      subtitle: 'Total suppliers'
    },
    {
      title: 'Overdue Invoices',
      value: metrics?.overdueCount || 0,
      icon: '⚠️',
      color: '#F44336',
      bgColor: '#FFEBEE',
      subtitle: 'Requires attention'
    },
    {
      title: 'Early Payment Savings',
      value: `₹${formatCurrency(metrics?.earlyPaymentSavings || 0)}`,
      icon: '💸',
      color: '#4CAF50',
      bgColor: '#E8F5E9',
      subtitle: 'Discount earned'
    }
  ];

  return (
    <div className="dashboard-metrics">
      <div className="row">
        {metricCards.map((card, index) => (
          <div key={index} className="col-lg-3 col-md-6" style={{ marginBottom: '20px' }}>
            <div 
              className="metric-card" 
              style={{ 
                borderLeft: `4px solid ${card.color}`,
                transition: 'all 0.3s ease'
              }}
            >
              <div className="metric-header">
                <div 
                  className="metric-icon" 
                  style={{ 
                    backgroundColor: card.bgColor,
                    color: card.color 
                  }}
                >
                  {card.icon}
                </div>
                <div className="metric-info">
                  <h6 className="metric-title">{card.title}</h6>
                  <p className="metric-subtitle">{card.subtitle}</p>
                </div>
              </div>
              <div className="metric-value" style={{ color: card.color }}>
                {card.value}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Helper function to format currency
const formatCurrency = (amount) => {
  if (amount >= 10000000) {
    return `${(amount / 10000000).toFixed(2)} Cr`;
  } else if (amount >= 100000) {
    return `${(amount / 100000).toFixed(2)} L`;
  } else if (amount >= 1000) {
    return `${(amount / 1000).toFixed(2)} K`;
  }
  return amount.toLocaleString('en-IN');
};

export default DashboardMetrics;

